
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface CompanySearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const CompanySearch: React.FC<CompanySearchProps> = ({ searchQuery, setSearchQuery }) => {
  return (
    <div className="mb-4">
      <div className="relative">
        <Search className="absolute top-3 left-3 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search companies..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
};

export default CompanySearch;
